import type { AgentId, ChannelId, ExecutionMode } from "./types";

export type AgentCatalogEntry = {
  id: AgentId;
  label: string;
  provider: string;
  executionModes: ExecutionMode[];
  channels: ChannelId[];
  providerProductIdentityVerified: boolean;
  restriction: string;
};

export const AGENT_CATALOG: AgentCatalogEntry[] = [
  {
    id: "claude",
    label: "Claude Duet",
    provider: "Anthropic",
    executionModes: ["from_scan", "provider_model_simulation", "technical_check"],
    channels: ["website"],
    providerProductIdentityVerified: false,
    restriction: "SiteGlue can run a Claude Duet model walk of public pages. That is not the Claude consumer app.",
  },
  {
    id: "grok",
    label: "Grok Bot",
    provider: "xAI",
    executionModes: ["from_scan", "provider_model_simulation", "not_testable"],
    channels: ["website"],
    providerProductIdentityVerified: false,
    restriction: "SiteGlue can run a Grok model walk of public pages. That is not the Grok consumer app.",
  },
  {
    id: "dots",
    label: "Dots",
    provider: "OpenAI",
    executionModes: ["from_scan", "not_testable"],
    channels: ["website"],
    providerProductIdentityVerified: false,
    restriction: "No authorized Dots connector. Marked not testable for live runs.",
  },
  {
    id: "muse",
    label: "Muse",
    provider: "Meta",
    executionModes: ["from_scan", "not_testable"],
    channels: ["website"],
    providerProductIdentityVerified: false,
    restriction: "No authorized Muse consumer runtime.",
  },
  {
    id: "openclaw",
    label: "OpenClaw",
    provider: "OpenClaw",
    executionModes: ["from_scan", "not_testable"],
    channels: ["website"],
    providerProductIdentityVerified: false,
    restriction: "No authorized OpenClaw connector.",
  },
];

/** Older scans could store Perplexity. Keep parsing it. */
const LEGACY_AGENT_IDS: AgentId[] = ["perplexity"];

export function agentById(id: string | undefined): AgentCatalogEntry | undefined {
  return AGENT_CATALOG.find((agent) => agent.id === id);
}

export function isAgentId(id: string): id is AgentId {
  return AGENT_CATALOG.some((agent) => agent.id === id) || LEGACY_AGENT_IDS.includes(id as AgentId);
}

export const ALL_AGENT_IDS: AgentId[] = AGENT_CATALOG.map((agent) => agent.id);

export function agentSupportsLiveProvider(id: AgentId): boolean {
  return AGENT_CATALOG.find((agent) => agent.id === id)?.executionModes.includes("live_provider_agent") === true;
}
